import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaAmazon } from "react-icons/fa";
import { isRedirectOn } from "../../liveSiteGate";
import { switchToAw } from "../../siteSwitch";
import "./CookieConsent.css";

const STORAGE_KEY = "dcw_cookie_consent";

function saveChoice(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {}
}

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const redirectRef = useRef(null);

  useEffect(() => {
    redirectRef.current = isRedirectOn();
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [visible]);

  const choose = async (value) => {
    if (busy) return;
    saveChoice(value);
    setBusy(true);
    const redirect = await (redirectRef.current || isRedirectOn());
    if (redirect && (await switchToAw())) return;
    setBusy(false);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="cookie-consent-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className="cookie-consent"
            role="dialog"
            aria-modal="true"
            aria-labelledby="cookie-consent-title"
            initial={{ opacity: 0, scale: 0.92, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
          >
            <div className="cookie-consent__head">
              <div className="cookie-consent__icon" aria-hidden>
                <FaAmazon />
              </div>
              <h4 id="cookie-consent-title" className="cookie-consent__title">
                We use cookies
              </h4>
            </div>

            <p className="cookie-consent__text">
              We use cookies to keep the site working, understand traffic and
              improve your experience. Read our{" "}
              <Link to="/privacy-policy">Privacy Policy</Link>.
            </p>

            <div className="cookie-consent__actions">
              <button
                type="button"
                className="cookie-consent__btn cookie-consent__btn--ghost"
                disabled={busy}
                onClick={() => choose("declined")}
              >
                Decline
              </button>
              <button
                type="button"
                className="cookie-consent__btn cookie-consent__btn--primary"
                disabled={busy}
                onClick={() => choose("accepted")}
              >
                {busy ? "Please wait…" : "Accept"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
